import { observable } from 'mobx'

export default class TrackersStore {
  @observable trackers = []
  @observable tracker = []
  @observable created = false

  updateTrackers(data) {
    this.trackers = data
  }

  updateTracker(data) {
    this.tracker = data
  }

  updateTrackerById(id) {
    var t = this.trackers.filter(e => e.id === id)
    if (t.length === 1) {
      this.tracker = t[0]
    } else if (t.length === 0) {
      console.log('no such tracker')
    } else {
      console.log(t.length + ' trackers for the same one, error!')
    }
  }

  updateCreated() {
    this.created = true
  }
}



// WEBPACK FOOTER //
// ./src/stores/TrackersStore.js